import { coreApi } from '@modules/core/api';
import { useQuery } from '@tanstack/react-query';
import { CreditsPriceListActionName } from '@modules/core/api/types';
import { useEffect } from 'react';
import { toast } from '@huspy/forge/shared';
import { IS_SPAIN_ENV } from '@modules/core/utils';

const useGetCreditsPriceList = (isEnabled = false) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['credits-price-list'],
    queryFn: () => coreApi.getCreditsPriceList(),
    staleTime: 0,
    enabled: isEnabled && !IS_SPAIN_ENV,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  const getActionPrice = (actionName: CreditsPriceListActionName) => data?.action_type_configurations
    .find((item) => item.action_type === actionName)
    ?.amount;

  return {
    data, isLoading, error, refetch, isRefetching, getActionPrice,
  };
};

export default useGetCreditsPriceList;
